import { NavLink } from "react-router-dom";
import { Boxes, Home, X } from "lucide-react";
import { env } from "@/config/env";
import { ROUTES } from "@/constants/routes";
import { useMediaQuery } from "@/hooks";
import { cn } from "@/lib/cn";
import { useUiStore } from "@/store";
import { IconButton } from "@/components/ui";

const navItems = [
  { to: ROUTES.dashboard, label: "Home", icon: Home, end: true },
  { to: ROUTES.uiKit, label: "UI Kit", icon: Boxes, end: false },
];

export function Sidebar() {
  const sidebarOpen = useUiStore((state) => state.sidebarOpen);
  const setSidebarOpen = useUiStore((state) => state.setSidebarOpen);
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  if (!sidebarOpen && isDesktop) {
    return (
      <aside className="hidden w-16 shrink-0 border-r border-border bg-surface lg:flex lg:flex-col">
        <div className="flex h-14 items-center justify-center border-b border-border">
          <span className="h-7 w-7 rounded-lg bg-primary text-center text-sm font-bold leading-7 text-white">
            P
          </span>
        </div>
        <nav className="flex flex-col items-center gap-1 p-2">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              title={item.label}
              className={({ isActive }) =>
                cn(
                  "flex h-10 w-10 items-center justify-center rounded-lg text-fg-muted hover:bg-surface-muted hover:text-fg",
                  isActive && "bg-primary/10 text-primary",
                )
              }
            >
              <item.icon className="h-4 w-4" />
            </NavLink>
          ))}
        </nav>
      </aside>
    );
  }

  if (!sidebarOpen && !isDesktop) return null;

  return (
    <>
      {!isDesktop ? (
        <button
          type="button"
          aria-label="Close sidebar"
          className="fixed inset-0 z-30 bg-black/40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      ) : null}
      <aside
        className={cn(
          "z-40 flex w-64 shrink-0 flex-col border-r border-border bg-surface",
          isDesktop ? "relative" : "fixed inset-y-0 left-0",
        )}
      >
        <div className="flex h-14 items-center justify-between gap-2 border-b border-border px-4">
          <div className="flex items-center gap-2">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-lg bg-primary text-sm font-bold text-white">
              P
            </span>
            <span className="text-sm font-semibold text-fg">{env.appName}</span>
          </div>
          {!isDesktop ? (
            <IconButton label="Close sidebar" onClick={() => setSidebarOpen(false)}>
              <X className="h-4 w-4" />
            </IconButton>
          ) : null}
        </div>
        <nav className="flex flex-col gap-1 p-3">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => {
                if (!isDesktop) setSidebarOpen(false);
              }}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-fg-muted hover:bg-surface-muted hover:text-fg",
                  isActive && "bg-primary/10 text-primary",
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
}
